import { AxiosResponse } from "axios";

import api from "services/api";

import serveRequestErrors from "common/serve-request-errors";

import { SelectOption } from "dto/components/app-select-input-dto";
import ErrorResponseDto from "dto/services/error-response-dto";

const getSolutionCategory = async (id: string): Promise<AxiosResponse<{ content: SelectOption[] }>> => {
	const queryParams = { search: "", page: 0, size: 100 };

	let response = null;

	let errorMessage = "";

	try {
		const res = await api.get.solution.services(id, queryParams);

		const content = res.data.data.list.content.filter((o: { status: string }) => o.status === "active").map((o: any) => ({ label: o.title, value: o.id }));

		response = { ...res, data: { ...res.data, content: content } };
	} catch (error) {
		const err = error as Error | ErrorResponseDto;
		serveRequestErrors(err);
	}

	if (response) return response;

	throw errorMessage;
};

export default getSolutionCategory;
